import { Mutation, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { IProduct } from '@collections/products/interfaces';

export interface UpdateViewsProductCounterResponse {
  updateViewsProductCounter: IProduct;
}

@Injectable()
export class UpdateViewsProductCounterGQL extends Mutation<UpdateViewsProductCounterResponse> {
  document = gql`
  mutation updateViewsProductCounter ($id: ObjectId!){
    updateViewsProductCounter(id: $id){
      _id
    }
  }
  `;
}
